export default {
  path: 'renewal-proposal',
  component: () => import(/* webpackChunkName: "financial-predictions-renewal-proposal" */ './RenewalProposal'),
  meta: { requiresAuth: true }
}
